export default "__VITE_ASSET__sTQcIv1R__"